/* MARISOLE size advisor — v4.
   - NO preselected answers: every choice starts empty; Continua is
     disabled (real disabled attribute + aria-disabled) until the
     customer actively picks an answer or enters a valid number.
   - Going back keeps only answers the customer chose herself.
   - Ricomincia clears everything.
   - Visible labels: \"Vestibilità equilibrata\" and \"Comoda\" (internal
     algorithm values 'uniform'/'morbida' unchanged for compatibility).
   Algorithm, size-chart data, variant selection and the
   estimated/advisor:false safety logic are unchanged. */
(function () {
  'use strict';
  var CFG = window.MarisoleSizeAdvisorConfig || {
    ease: { aderente: 1, regolare: 4, morbida: 8 },
    easeIdealWindow: 10,
    deficitPenalty: 4, surplusPenalty: 0.6,
    weights: { bust: 0.45, waist: 0.30, hips: 0.25 },
    focusBoost: 0.15,
    twoSizeThreshold: 0.15
  };
  var SIZES_ORDER = ['XS','S','M','L','XL','2XL','3XL','4XL','5XL'];
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  var TORSO = 'M8 3.5c.5 2.2-.5 3.4-1.4 4.7 1 1.6 1.5 3.1 1.2 4.8-.3 1.8-1.3 3.2-1.3 5.2V21h11v-2.8c0-2-1-3.4-1.3-5.2-.3-1.7.2-3.2 1.2-4.8C16.5 6.9 15.5 5.7 16 3.5';
  var ICONS = {
    height: '<svg viewBox=\"0 0 24 24\" aria-hidden=\"true\"><circle cx=\"9\" cy=\"4.6\" r=\"1.7\"/><path d=\"M9 7c-1.9.5-2.5 2.1-2.5 4 0 2.4.8 4 .8 6.1V21h3.4v-3.9c0-2.1.8-3.7.8-6.1 0-1.9-.6-3.5-2.5-4z\"/><path d=\"M17.5 3v18M15.8 3h3.4M15.8 21h3.4\"/></svg>',
    weight: '<svg viewBox=\"0 0 24 24\" aria-hidden=\"true\"><rect x=\"4\" y=\"5\" width=\"16\" height=\"14\" rx=\"2.5\"/><path d=\"M8.3 10.2a4.8 4.8 0 0 1 7.4 0\"/><path d=\"M12 10.4l1.7-1.7\"/></svg>',
    bust: '<svg viewBox=\"0 0 24 24\" aria-hidden=\"true\"><path d=\"' + TORSO + '\"/><path d=\"M8.6 9c1 1.3 2.2 1.9 3.4 1.9s2.4-.6 3.4-1.9\"/></svg>',
    waist: '<svg viewBox=\"0 0 24 24\" aria-hidden=\"true\"><path d=\"' + TORSO + '\"/><path d=\"M8.1 13.2h7.8\"/></svg>',
    hips: '<svg viewBox=\"0 0 24 24\" aria-hidden=\"true\"><path d=\"' + TORSO + '\"/><path d=\"M7.4 17.2c1.4 1 2.9 1.5 4.6 1.5s3.2-.5 4.6-1.5\"/></svg>',
    uniform: '<svg viewBox=\"0 0 24 24\" aria-hidden=\"true\"><path d=\"' + TORSO + '\"/></svg>',
    fit1: '<svg viewBox=\"0 0 24 24\" aria-hidden=\"true\"><path d=\"M9.7 3.5c0 1.5-.6 2.4-.6 3.8l1 1.9-.9 11.3h5.6l-.9-11.3 1-1.9c0-1.4-.6-2.3-.6-3.8\"/></svg>',
    fit2: '<svg viewBox=\"0 0 24 24\" aria-hidden=\"true\"><path d=\"M9.5 3.5c0 1.6-.8 2.6-.8 4.1l1.3 1.9-1.6 11h7.2l-1.6-11 1.3-1.9c0-1.5-.8-2.5-.8-4.1\"/></svg>',
    fit3: '<svg viewBox=\"0 0 24 24\" aria-hidden=\"true\"><path d=\"M9.5 3.5c0 1.6-1.1 2.6-1.3 4.1l1.3 1.9L6 20.5h12l-3.5-11 1.3-1.9c-.2-1.5-1.3-2.5-1.3-4.1\"/></svg>',
    prev: '<svg viewBox=\"0 0 16 16\" aria-hidden=\"true\"><path d=\"M10 2 4 8l6 6\"/></svg>'
  };
  function emptyAnswers() { return { size: null, height: null, weight: null, focus: null, fit: null, bust: null, waist: null, hips: null }; }

  var proto = Object.create(HTMLElement.prototype);

  proto.connectedCallback = function () {
    if (this.__init) return;
    this.__init = true;
    var root = this.closest('[data-ms-sizeguide]') || document;
    var dataEl = root.querySelector('[data-ms-advisor-data]');
    var chartEl = root.querySelector('[data-ms-sizechart]');
    try {
      this.pdata = JSON.parse(dataEl.textContent);
      this.chart = chartEl ? JSON.parse(chartEl.textContent) : null;
    } catch (e) { console.warn('MarisoleSizeAdvisor: dati non validi', e); this.hidden = true; return; }
    if (!this.chart || !this.chart.rows || !this.chart.rows.length) { this.hidden = true; return; }
    if (this.chart.advisor === false) { this.hidden = true; return; }
    if (!this.validateChart()) {
      console.warn('MarisoleSizeAdvisor: tabella non monotona per ' + this.pdata.handle + ' — adviseur disattivato');
      this.innerHTML = '<p class=\"msadv__result-text\" style=\"text-align:left\">Consulta la tabella taglie prima di scegliere.</p>';
      return;
    }
    this.est = this.chart.estimated === true;
    this.answers = emptyAnswers();
    this.step = 0;
    this.render();
  };
  proto.disconnectedCallback = function () { this.__init = false; this.innerHTML = ''; };

  proto.validateChart = function () {
    var self = this;
    var ok = true;
    ['bust', 'waist', 'hips', 'bust_half'].forEach(function (k) {
      var i = self.chart.keys.indexOf(k);
      if (i < 0) return;
      var prev = -1;
      self.chart.rows.forEach(function (r) {
        var v = parseFloat(r[i]);
        if (isNaN(v)) { ok = false; return; }
        if (v < prev) ok = false;
        prev = v;
      });
    });
    return ok;
  };

  proto.sizesAvailable = function () {
    return this.pdata.variants.filter(function (v) { return v.available; }).map(function (v) { return v.size; })
      .filter(function (s, i, a) { return a.indexOf(s) === i; })
      .sort(function (a, b) { return SIZES_ORDER.indexOf(a) - SIZES_ORDER.indexOf(b); });
  };
  proto.colIndex = function (key) { return this.chart.keys.indexOf(key); };
  proto.garment = function (row, key) {
    var i = this.colIndex(key);
    if (i < 0 && key === 'bust') { i = this.colIndex('bust_half'); if (i >= 0) return parseFloat(this.chart.rows[row][i]) * 2; }
    if (i < 0) return null;
    var v = parseFloat(this.chart.rows[row][i]);
    return isNaN(v) ? null : v;
  };

  proto.compute = function () {
    var a = this.answers, chart = this.chart, self = this;
    var chartSizes = chart.rows.map(function (r) { return r[0]; });
    var rec = null, second = null, between = false, nMeas = 0;
    if (!this.est) {
      var measures = {};
      if (a.bust) measures.bust = a.bust;
      if (a.waist) measures.waist = a.waist;
      if (a.hips) measures.hips = a.hips;
      var usable = Object.keys(measures).filter(function (k) { return self.garment(0, k) !== null; });
      nMeas = usable.length;
      if (nMeas > 0) {
        var w = {}; var tot = 0;
        usable.forEach(function (k) { w[k] = CFG.weights[k] || 0.3; });
        var focusKey = { seno: 'bust', vita: 'waist', fianchi: 'hips' }[a.focus];
        if (focusKey && w[focusKey] != null) w[focusKey] += CFG.focusBoost;
        usable.forEach(function (k) { tot += w[k]; });
        usable.forEach(function (k) { w[k] = w[k] / tot; });
        var ease = a.fit && CFG.ease[a.fit] != null ? CFG.ease[a.fit] : CFG.ease.regolare;
        var scores = chart.rows.map(function (r, ri) {
          var pen = 0;
          usable.forEach(function (k) {
            var g = self.garment(ri, k);
            var need = measures[k] + ease;
            var diff = g - need;
            if (diff < 0) pen += (-diff) * CFG.deficitPenalty * w[k];
            else if (diff > CFG.easeIdealWindow) pen += (diff - CFG.easeIdealWindow) * CFG.surplusPenalty * w[k];
          });
          return { size: r[0], pen: pen, ri: ri };
        });
        scores.sort(function (x, y) { return x.pen - y.pen || x.ri - y.ri; });
        rec = scores[0]; second = scores[1];
        if (second && rec.pen > 0 && Math.abs(second.pen - rec.pen) <= rec.pen * CFG.twoSizeThreshold + 0.5) {
          between = true;
          if (SIZES_ORDER.indexOf(second.size) > SIZES_ORDER.indexOf(rec.size)) { var t = rec; rec = second; second = t; }
        }
        var idx = chartSizes.indexOf(rec.size);
        while (idx < chartSizes.length - 1) {
          var tooSmall = usable.some(function (k) { return self.garment(idx, k) < measures[k]; });
          if (!tooSmall) break;
          idx++;
        }
        rec = { size: chartSizes[idx] };
      }
    }
    if (!rec) {
      if (!a.size) return null;
      var i2 = chartSizes.indexOf(a.size);
      if (i2 < 0) { i2 = 0; var oi = SIZES_ORDER.indexOf(a.size); for (var j = 0; j < chartSizes.length; j++) { if (SIZES_ORDER.indexOf(chartSizes[j]) >= oi) { i2 = j; break; } i2 = j; } }
      if (a.fit === 'morbida' && i2 < chartSizes.length - 1) i2++;
      rec = { size: chartSizes[i2] };
      nMeas = 0;
    }
    var avail = this.sizesAvailable();
    var finalSize = rec.size, clamped = false;
    if (avail.indexOf(finalSize) < 0 && avail.length) {
      clamped = true;
      var target = SIZES_ORDER.indexOf(finalSize);
      var larger = avail.filter(function (s) { return SIZES_ORDER.indexOf(s) >= target; });
      finalSize = larger.length ? larger[0] : avail[avail.length - 1];
    }
    var conf = nMeas >= 2 ? 2 : (nMeas === 1 ? 1 : 0);
    if (this.est) conf = 1;
    return { size: finalSize, between: between, altSize: between && second ? second.size : null, conf: conf, clamped: clamped, origSize: rec.size, nMeas: nMeas };
  };

  proto.lengthNote = function () {
    if (this.est) return '';
    var li = this.colIndex('length');
    if (li < 0 || !this.answers.height) return '';
    var res = this.compute(); if (!res) return '';
    var row = this.chart.rows.map(function (r) { return r[0]; }).indexOf(res.size);
    if (row < 0) row = 0;
    var len = parseFloat(this.chart.rows[row][li]);
    if (isNaN(len)) return '';
    var hem = this.answers.height * 0.82 - len;
    var pos = hem < 10 ? 'circa alla caviglia' : hem < 22 ? 'circa al polpaccio' : hem < 45 ? 'indicativamente sotto il ginocchio' : 'indicativamente sopra il ginocchio';
    return 'In base alla tua altezza, l’abito dovrebbe arrivare ' + pos + '.';
  };

  proto.card = function (label, val, group, sub, icon) {
    var b = el('button', 'msadv__card');
    b.type = 'button';
    b.setAttribute('data-val', val);
    b.setAttribute('data-group', group);
    var pressed = this.answers[group] != null && String(this.answers[group]) === String(val);
    b.setAttribute('aria-pressed', String(pressed));
    b.innerHTML = (icon ? icon : '') + '<span>' + label + '</span>' + (sub ? '<small>' + sub + '</small>' : '');
    return b;
  };

  proto.numField = function (key, label, help, min, max, start) {
    var wrap = el('div', 'msadv__measure');
    var id = 'msadv-' + key + '-' + Math.random().toString(36).slice(2, 7);
    wrap.innerHTML = '<div class=\"msadv__field\"><label for=\"' + id + '\">' + label + ' (cm)</label>' +
      '<button type=\"button\" class=\"msadv__stepbtn\" data-delta=\"-1\" data-for=\"' + id + '\" aria-label=\"Diminuisci\">−</button>' +
      '<input id=\"' + id + '\" data-key=\"' + key + '\" data-min=\"' + min + '\" data-max=\"' + max + '\" data-start=\"' + start + '\" type=\"number\" inputmode=\"decimal\" step=\"1\">' +
      '<button type=\"button\" class=\"msadv__stepbtn\" data-delta=\"1\" data-for=\"' + id + '\" aria-label=\"Aumenta\">+</button></div>' +
      '<p class=\"msadv__measure-help\">' + help + '</p>';
    if (this.answers[key]) wrap.querySelector('input').value = this.answers[key];
    return wrap;
  };

  proto.stepGroups = function () {
    return this.est ? ['size', 'height', 'weight', 'fit'] : ['size', 'height', 'weight', 'focus', 'fit', 'measures'];
  };

  proto.render = function () {
    var self = this;
    var avail = this.sizesAvailable();
    var steps = [];
    steps.push(function (c) {
      c.appendChild(el('h3', 'msadv__q', 'Quale taglia indossi più spesso?'));
      var g = el('div', 'msadv__cards'); ['XS','S','M','L','XL','2XL','3XL','4XL'].filter(function (s) { return avail.indexOf(s) >= 0 || ['XS','S','M','L','XL','2XL'].indexOf(s) >= 0; }).forEach(function (s) { g.appendChild(self.card(s, s, 'size')); });
      c.appendChild(g);
    });
    steps.push(function (c) {
      c.appendChild(el('h3', 'msadv__q', 'Quanto sei alta?'));
      var g = el('div', 'msadv__cards msadv__cards--wide');
      [['Meno di 155 cm',150],['155–164 cm',160],['165–174 cm',170],['175–184 cm',180],['185 cm o più',187]].forEach(function (p) { g.appendChild(self.card(p[0], String(p[1]), 'height', null, ICONS.height)); });
      c.appendChild(g);
      var d = el('details', 'msadv__exact', '<summary>Inserisci la tua altezza esatta</summary>');
      d.appendChild(el('div', 'msadv__field', '<label for=\"msadv-hx\">Altezza (cm)</label><input id=\"msadv-hx\" data-exact=\"height\" data-min=\"130\" data-max=\"210\" type=\"number\" inputmode=\"decimal\">'));
      c.appendChild(d);
    });
    steps.push(function (c) {
      c.appendChild(el('h3', 'msadv__q', 'Qual è il tuo peso?'));
      c.appendChild(el('p', 'msadv__sub', 'Serve solo come informazione di supporto.'));
      var g = el('div', 'msadv__cards msadv__cards--wide');
      [['Meno di 50 kg',47],['50–59 kg',55],['60–69 kg',65],['70–79 kg',75],['80–89 kg',85],['90–99 kg',95],['100 kg o più',105]].forEach(function (p) { g.appendChild(self.card(p[0], String(p[1]), 'weight', null, ICONS.weight)); });
      c.appendChild(g);
      var d = el('details', 'msadv__exact', '<summary>Inserisci il tuo peso esatto</summary>');
      d.appendChild(el('div', 'msadv__field', '<label for=\"msadv-wx\">Peso (kg)</label><input id=\"msadv-wx\" data-exact=\"weight\" data-min=\"35\" data-max=\"200\" type=\"number\" inputmode=\"decimal\">'));
      c.appendChild(d);
    });
    if (!this.est) {
      steps.push(function (c) {
        c.appendChild(el('h3', 'msadv__q', 'Dove preferisci una vestibilità più comoda?'));
        var g = el('div', 'msadv__cards msadv__cards--wide');
        g.appendChild(self.card('Seno', 'seno', 'focus', 'Preferisco più comfort sul seno', ICONS.bust));
        g.appendChild(self.card('Vita', 'vita', 'focus', 'Preferisco più comfort in vita', ICONS.waist));
        g.appendChild(self.card('Fianchi', 'fianchi', 'focus', 'Preferisco più comfort sui fianchi', ICONS.hips));
        g.appendChild(self.card('Vestibilità equilibrata', 'uniform', 'focus', 'Preferisco una vestibilità uniforme e confortevole', ICONS.uniform));
        c.appendChild(g);
      });
    }
    steps.push(function (c) {
      c.appendChild(el('h3', 'msadv__q', 'Come preferisci che vesta?'));
      var g = el('div', 'msadv__cards msadv__cards--wide');
      g.appendChild(self.card('Aderente', 'aderente', 'fit', 'Più vicina al corpo', ICONS.fit1));
      g.appendChild(self.card('Regolare', 'regolare', 'fit', 'Comoda e naturale', ICONS.fit2));
      g.appendChild(self.card('Comoda', 'morbida', 'fit', 'Più ampia e rilassata', ICONS.fit3));
      c.appendChild(g);
    });
    if (!this.est) {
      steps.push(function (c) {
        c.appendChild(el('h3', 'msadv__q', 'Aggiungi le tue misure'));
        c.appendChild(el('p', 'msadv__sub', 'Questo passaggio rende il consiglio più preciso.'));
        c.appendChild(self.numField('bust', 'Circonferenza del seno', 'Misura intorno alla parte più ampia del seno.', 60, 180, 90));
        c.appendChild(self.numField('waist', 'Circonferenza della vita', 'Misura intorno al punto più stretto della vita.', 50, 180, 75));
        c.appendChild(self.numField('hips', 'Circonferenza dei fianchi', 'Misura intorno alla parte più ampia dei fianchi.', 70, 200, 98));
        var sk = el('button', 'msadv__skip', 'Non conosco le mie misure<small>Puoi continuare, ma il consiglio sarà indicativo.</small>');
        sk.type = 'button'; sk.setAttribute('data-skip', '1'); c.appendChild(sk);
        c.appendChild(el('p', 'msadv__error', ''));
      });
    }

    this.innerHTML = '';
    var total = steps.length;
    this.__advancing = false;
    if (this.step < total) {
      if (this.step === 0) {
        this.appendChild(el('p', 'msadv__intro', 'Rispondi a poche semplici domande. Ti aiuteremo a scegliere la taglia più adatta a te.'));
        if (this.est) this.appendChild(el('p', 'msadv__sub', 'Questo prodotto non dispone ancora di una tabella taglie specifica: il consiglio sarà indicativo.'));
        this.appendChild(el('p', 'msadv__privacy', 'I tuoi dati vengono utilizzati solo per calcolare il consiglio e non vengono salvati.'));
      }
      this.appendChild(el('div', 'msadv__progress', '<span class=\"msadv__progress-label\">' + (this.step + 1) + ' di ' + total + '</span><span class=\"msadv__progress-bar\"><span class=\"msadv__progress-fill\" style=\"width:' + Math.round(((this.step + 1) / total) * 100) + '%\"></span></span>'));
      var stepBox = el('div', 'msadv__step'); steps[this.step](stepBox); this.appendChild(stepBox);
      var nav = el('div', 'msadv__nav');
      var back = el('button', 'msadv__back', ICONS.prev + ' Indietro'); back.type = 'button'; back.style.visibility = this.step === 0 ? 'hidden' : 'visible';
      var lastLabel = this.est ? 'Vedi la taglia suggerita' : 'Vedi il risultato';
      var next = el('button', 'msadv__next', (this.step === total - 1 ? lastLabel : 'Continua'));
      next.type = 'button';
      nav.appendChild(back); nav.appendChild(next); this.appendChild(nav);
      this.__nextBtn = next;
      this.updateNextState();
      back.addEventListener('click', function () { self.step--; self.render(); });
      next.addEventListener('click', function () {
        if (next.disabled) return;
        self.collectStep(stepBox); self.step++; self.render();
      });
    } else {
      this.renderResult();
    }
    this.appendChild(el('p', 'visually-hidden', '')).setAttribute('role', 'status');
    this.bindStep();
  };

  proto.updateNextState = function () {
    if (!this.__nextBtn) return;
    var groups = this.stepGroups();
    var g = groups[this.step];
    var ok = false;
    if (g === 'measures') {
      var self = this;
      ok = false;
      this.querySelectorAll('input[data-key]').forEach(function (i) {
        var v = parseFloat(i.value);
        if (!isNaN(v) && v >= parseFloat(i.getAttribute('data-min')) && v <= parseFloat(i.getAttribute('data-max'))) ok = true;
      });
    } else {
      ok = this.answers[g] != null;
    }
    this.__nextBtn.disabled = !ok;
    this.__nextBtn.setAttribute('aria-disabled', String(!ok));
  };

  proto.advance = function () {
    var self = this;
    if (this.__advancing) return;
    this.__advancing = true;
    setTimeout(function () { self.step++; self.render(); }, 180);
  };

  proto.bindStep = function () {
    var self = this;
    this.querySelectorAll('.msadv__card').forEach(function (b) {
      b.addEventListener('click', function () {
        var g = b.getAttribute('data-group');
        self.answers[g] = b.getAttribute('data-val');
        if (g === 'height' || g === 'weight') self.answers[g] = parseFloat(b.getAttribute('data-val'));
        self.querySelectorAll('.msadv__card[data-group=\"' + g + '\"]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        self.updateNextState();
        self.advance();
      });
    });
    this.querySelectorAll('input[data-exact]').forEach(function (i) {
      function commit() {
        var v = parseFloat(i.value);
        if (isNaN(v) || v < parseFloat(i.getAttribute('data-min')) || v > parseFloat(i.getAttribute('data-max'))) return;
        self.answers[i.getAttribute('data-exact')] = v;
        self.updateNextState();
        self.advance();
      }
      i.addEventListener('change', commit);
      i.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); commit(); } });
    });
    this.querySelectorAll('input[data-key]').forEach(function (i) {
      i.addEventListener('input', function () { self.updateNextState(); });
    });
    this.querySelectorAll('.msadv__stepbtn').forEach(function (b) {
      b.addEventListener('click', function () {
        var inp = self.querySelector('#' + b.getAttribute('data-for'));
        if (inp.value === '') {
          inp.value = inp.getAttribute('data-start') || inp.getAttribute('data-min');
        } else {
          inp.value = (parseFloat(inp.value) || 0) + parseInt(b.getAttribute('data-delta'), 10);
        }
        inp.dispatchEvent(new Event('input'));
        self.updateNextState();
      });
    });
    var skip = this.querySelector('[data-skip]');
    if (skip) skip.addEventListener('click', function () { self.answers.bust = self.answers.waist = self.answers.hips = null; self.step++; self.render(); });
  };

  proto.collectStep = function (box) {
    var self = this;
    box.querySelectorAll('input[data-exact]').forEach(function (i) { var v = parseFloat(i.value); if (!isNaN(v)) self.answers[i.getAttribute('data-exact')] = v; });
    var bad = false;
    box.querySelectorAll('input[data-key]').forEach(function (i) {
      var v = parseFloat(i.value);
      if (i.value === '') { self.answers[i.getAttribute('data-key')] = null; return; }
      if (isNaN(v) || v < parseFloat(i.getAttribute('data-min')) || v > parseFloat(i.getAttribute('data-max'))) { bad = true; return; }
      self.answers[i.getAttribute('data-key')] = v;
    });
    if (bad) {
      var err = box.querySelector('.msadv__error'); if (err) err.textContent = 'Controlla la misura inserita.';
      this.step--;
    }
  };

  proto.renderResult = function () {
    var self = this;
    var res = this.compute();
    var box = el('div', 'msadv__result');
    if (!res) {
      box.appendChild(el('p', 'msadv__result-text', 'Non abbiamo abbastanza informazioni per consigliarti una taglia con sicurezza.'));
      var acts0 = el('div', 'msadv__result-row');
      var r1 = el('button', 'msadv__secondary', 'Modifica le risposte'); r1.type = 'button';
      r1.addEventListener('click', function () { self.step = 0; self.render(); });
      var r2 = el('button', 'msadv__secondary', 'Tabella taglie'); r2.type = 'button'; r2.setAttribute('data-msadv-totable', '1');
      acts0.appendChild(r1); acts0.appendChild(el('span', 'msadv__dot', '·')); acts0.appendChild(r2);
      box.appendChild(acts0);
      this.appendChild(box); return;
    }
    var confTxt = ['Stima indicativa', 'Consiglio indicativo', 'Consiglio più preciso'][res.conf];
    var fitWord = this.answers.fit === 'morbida' ? 'comoda e rilassata' : this.answers.fit === 'aderente' ? 'più aderente' : 'regolare e confortevole';
    box.appendChild(el('p', 'msadv__result-label', res.between ? 'Sei tra due taglie' : (this.est || res.nMeas === 0 ? 'Taglia suggerita' : 'Taglia consigliata')));
    box.appendChild(el('p', 'msadv__result-size', res.between && res.altSize ? res.altSize + '–' + res.size : res.size));
    box.appendChild(el('span', 'msadv__result-conf', confTxt));
    var line1;
    if (res.between) line1 = 'Ti consigliamo la ' + res.size + ' per una vestibilità più comoda.';
    else if (res.nMeas > 0) line1 = 'In base alle tue misure, ti consigliamo la taglia ' + res.size + ' per una vestibilità ' + fitWord + '.';
    else line1 = 'Ti consigliamo la taglia ' + res.size + ' per una vestibilità ' + fitWord + '.';
    box.appendChild(el('p', 'msadv__result-text', line1));
    if (this.est) box.appendChild(el('p', 'msadv__result-note', 'Consiglio indicativo: per questo articolo non è disponibile una tabella taglie specifica.'));
    else if (res.nMeas === 0) box.appendChild(el('p', 'msadv__result-note', 'Per un consiglio più preciso, aggiungi le tue misure.'));
    if (res.clamped) box.appendChild(el('p', 'msadv__result-note', 'La taglia calcolata (' + res.origSize + ') non è disponibile: ti proponiamo la più vicina.'));
    var ln = this.lengthNote(); if (ln) box.appendChild(el('p', 'msadv__result-note', ln));
    var sel = el('button', 'msadv__next msadv__cta', 'Seleziona la taglia ' + res.size); sel.type = 'button';
    sel.addEventListener('click', function () { self.selectSize(res.size); });
    box.appendChild(sel);
    var row = el('div', 'msadv__result-row');
    var b1 = el('button', 'msadv__secondary', 'Modifica le risposte'); b1.type = 'button'; b1.addEventListener('click', function () { self.step = 0; self.render(); });
    var b2 = el('button', 'msadv__secondary', 'Tabella taglie'); b2.type = 'button'; b2.setAttribute('data-msadv-totable', '1');
    row.appendChild(b1); row.appendChild(el('span', 'msadv__dot', '·')); row.appendChild(b2);
    box.appendChild(row);
    var b3 = el('button', 'msadv__restart', 'Ricomincia'); b3.type = 'button';
    b3.addEventListener('click', function () { self.answers = emptyAnswers(); self.step = 0; self.render(); });
    box.appendChild(b3);
    this.appendChild(box);
    var live = this.querySelector('[role=status]'); if (live) live.textContent = confTxt + ': taglia ' + res.size;
  };

  proto.selectSize = function (size) {
    var inputs = document.querySelectorAll('.product-form__input input[type=radio]');
    var hit = null;
    inputs.forEach(function (i) { if (i.value === size && /taglia|size/i.test(i.name)) hit = i; });
    if (!hit) inputs.forEach(function (i) { if (i.value === size) hit = i; });
    if (hit) { hit.click(); hit.dispatchEvent(new Event('change', { bubbles: true })); }
    var modal = this.closest('.marisole-pdp-sizemodal');
    if (modal) { var c = modal.querySelector('[data-ms-sizeguide-close]'); if (c) c.click(); }
    var atc = document.querySelector('.product-form__submit');
    if (atc) atc.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
  };

  if (!customElements.get('marisole-size-advisor')) {
    var Ctor = function () { return Reflect.construct(HTMLElement, [], Ctor); };
    Ctor.prototype = proto;
    Object.setPrototypeOf(Ctor, HTMLElement);
    customElements.define('marisole-size-advisor', Ctor);
  }
})();